import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container } from "@mui/material";
import GestionFaqs from "../../components/faqs/GestionFaqs";
import useEventoStore from "../../stores/useEventoStore";
import { ROL } from "../../domain/staff/roles";
import { PADDING_COMO_HEADER } from "../../components/Header";

const Faqs = () => {
  const { id } = useParams();
  const userRole = useEventoStore(
    (state) => state.eventosPorId[id]?.data?.eventoUsuario?.idrol ?? null
  );

  useEffect(() => {
    document.title = "Preguntas frecuentes | PassGo";
  }, []);

  return (
    <Container maxWidth="md" sx={PADDING_COMO_HEADER}>
      <GestionFaqs eventoId={id} soloLectura={userRole !== ROL.OWNER} className="mt-3 mb-5" />
    </Container>
  );
};

export default Faqs;
